import { z } from 'zod'
import type { AppLanguageCode } from '@/lib/i18n'
import { getMailLinkCopy, type MailLinkFlow } from './mail-link-state'
import { buildSeo } from './seo'
import { createSiteTranslate } from './site-i18n'

export type { MailLinkFlow } from './mail-link-state'

export const mailLinkSearchSchema = z.object({
	ref: z.string().optional(),
	token: z.string().optional()
})

export function buildMailLinkSeo({
	appLanguage,
	flow,
	path
}: {
	appLanguage: AppLanguageCode
	flow: MailLinkFlow
	path: string
}) {
	const t = createSiteTranslate(appLanguage)
	const copy = getMailLinkCopy(flow)
	const seo = buildSeo({
		appLanguage,
		description: t(copy.subtitle),
		path,
		title: t(copy.title)
	})

	return {
		...seo,
		meta: [...seo.meta, { content: 'noindex, nofollow', name: 'robots' }]
	}
}
